import React from 'react';
 
const ErrorMessage = (props) => {
    const { text, show } = props;
    
    return show ? (
        <label className="err-lbl" >{text}</label>
    ) : null;
}

export default ErrorMessage;